import type { roles as en } from '@/i18n/locales/en/roles';
import type { Translation } from '@/i18n/types';

export const roles: Translation<typeof en> = {
  form: {
    person: 'Άτομο',
    choose: 'Επιλέξτε…',
    grant: 'Χορήγηση {{label}}',
    revoke: 'Ανάκληση {{label}}',
    back: 'Πίσω',
  },
  company: {
    title: 'Διαχειριστές εταιρείας',
    lead: 'Ένας διαχειριστής εταιρείας διαχειρίζεται τις δικές της πληροφορίες, τα τμήματα, τα μέλη και την παροχή πρόσβασης. Η χορήγηση και η ανάκληση καταγράφονται στο αρχείο ελέγχου.',
    label: 'διαχειριστής εταιρείας',
    rowsLabel: 'τα μέλη της εταιρείας',
  },
  department: {
    title: 'Διαχειριστές τμήματος (προπονητής)',
    lead: 'Ένας διαχειριστής τμήματος βλέπει τα μέλη και τα συγκεντρωτικά στοιχεία αυτού του τμήματος και, σύμφωνα με τον κανόνα ατομικής πρόσβασης, τα ατομικά στατιστικά που καλύπτει η βάση συγκατάθεσής του. Η χορήγηση και η ανάκληση καταγράφονται στο αρχείο ελέγχου.',
    label: 'διαχειριστής τμήματος',
    rowsLabel: 'τα μέλη του τμήματος',
  },
  admins: {
    title: 'Διαχειριστές πλατφόρμας',
    lead: 'Ένας διαχειριστής πλατφόρμας κατέχει κάθε εξουσία σε κάθε πεδίο εφαρμογής. Ο στόχος ενός διορισμού πρέπει να έχει δική του σύνδεση και να είναι κύρια ταυτότητα· ο τελευταίος διαχειριστής δεν μπορεί να αποσυρθεί.',
    name: 'Όνομα',
    email: 'Email',
    retire: 'Απόσυρση',
    rowsLabel: 'τους διαχειριστές',
    searchPeople: 'Αναζήτηση ατόμων',
    searchPlaceholder: 'Όνομα ή email',
    person: 'Άτομο',
    choose: 'Επιλέξτε…',
    noEligible: 'Κανένα κατάλληλο άτομο δεν ταιριάζει — χρειάζονται δική τους σύνδεση.',
    appoint: 'Διορισμός',
    usersLabel: 'τους χρήστες της πλατφόρμας',
  },
};
